import { ClassFlag } from "../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../library-js/dom-tools/ElementAttribute";
import { ElementSelector } from "../library-js/dom-tools/ElementSelector";

export class TemplateDefaults
{
  static readonly noPointers = new ClassFlag( "no--pointers" );
  static readonly noSelection = new ClassFlag( "no--selection" );
  
  static readonly selector = new ElementAttribute( "-selector" );
  static readonly targetSelector = new ElementAttribute( "-target--selector" );
  static readonly seed = new ElementAttribute( "-seed" );

  static readonly useAttribute = new ElementAttribute( "-use--attribute" );

  static getText( sourceElement:Element, attributeElement:Element = null )
  {
    attributeElement = attributeElement || sourceElement;

    if ( TemplateDefaults.useAttribute.in( attributeElement ) )
    {
      let attribute = new ElementAttribute( TemplateDefaults.useAttribute.from( attributeElement ) );
      return attribute.from( sourceElement );
    }

    return sourceElement.textContent;
  }

  static getSelected<T extends Element>( selectorElement:Element, sourceElement:Element = null ):T
  {
    let element = ElementSelector.queryValue( TemplateDefaults.selector, selectorElement, sourceElement );
    return element as T;
  }

  static getTarget<T extends Element>( targetElement:Element, sourceElement:Element = null ):T
  {
    let element = ElementSelector.queryValue( TemplateDefaults.targetSelector, targetElement, sourceElement );
    return element as T;
  }

  static getAllSelected<T extends Element>( selectorElement:Element, sourceElement:Element = null ):T[]
  {
    let element = ElementSelector.queryValueAll( TemplateDefaults.selector, selectorElement, sourceElement );
    return element as T[];
  }
  
}